var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 13.597C0 6.087 6.088 0 13.597 0h28.806C49.913 0 56 6.088 56 13.597v7.898a8.924 8.924 0 0 1-2.726 6.432l-.072.076L27.905 53.3a8.924 8.924 0 0 1-6.41 2.7h-7.898C6.087 56 0 49.913 0 42.403V13.597ZM30.446 43.84 43.84 30.446h-6.548a6.846 6.846 0 0 0-6.846 6.846v6.548ZM13.596 4.892a8.705 8.705 0 0 0-8.704 8.705v28.806a8.705 8.705 0 0 0 8.705 8.705h7.898a4.059 4.059 0 0 0 4.059-4.059v-9.757c0-6.483 5.255-11.738 11.738-11.738h9.757a4.059 4.059 0 0 0 4.059-4.059v-7.898a8.705 8.705 0 0 0-8.705-8.705H13.597Zm3.146 11.653a2.446 2.446 0 0 1 2.446-2.446h17.624a2.446 2.446 0 1 1 0 4.892H19.188a2.446 2.446 0 0 1-2.446-2.446Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo_mark.abb5177c95813ef79ead2f907030a190.svg";
export { ForwardRef as ReactComponent };